import Vue from 'vue';
import api from '../bu/api';

export default {
	namespaced: true,

	state: () => ({
		groups: {},
		groupsArray: [],
		groupRequiredMap: {}
	}),

	getters: {
		groups(state) {
			return state.groupsArray;
		},
		explicitItemGroups(state) {
			return state.groupsArray.filter((g) => g.is_explicit);
		},
		groupMap(state) {
			return state.groups;
		},
		groupRequiredMap(state) {
			return state.groupRequiredMap;
		},
		requiredGroups(state) {
			return state.groupsArray.filter((g) => state.groupRequiredMap[g.id])
		}
	},

	actions: {
		reset({commit}) {
			commit('reset');
		},
		setGroupRequired({commit}, {groupId, isRequired}) {
			commit('setGroupRequired', {groupId, isRequired});
		},
		async getAllItemGroups({commit}) {
			const response = await api.getAllItemGroups();
			commit('setGroups', response.data);
			return response.data.map((group) => group.id);
		},
		async getExplicitItemGroups({commit}) {
			const response = await api.getExplicitItemGroups();
			commit('setGroups', response.data);
			return response.data.map((group) => group.id);
		},
		async getItemGroup({ commit }, itemGroupId) {
			const response = await api.getItemGroup(itemGroupId);
			var group = response.data;
			group.relation_items = response.data.items.map((item) => {
				return {id: item.id, order: item.order}
			});
			commit('items/setItems', group.items, {root: true});
			group.items.forEach((item) => {
				if (item.specs) {
					item.specs.forEach((spec) => {
						commit('items/setSpec', spec, { root: true});
					});
				}
			})
			group.relation_specs = [];
			commit('setGroup', group);
		},
		async deleteGroup({commit}, groupId) {
			await api.deleteGroup(groupId);
			commit('deleteGroup', groupId);
		},
		async createItemGroup({commit}, {is_explicit, title, items, rules} = {}) {
			const response = await api.createItemGroup(is_explicit, title, items, rules);
			var group = response.data;
			group.relation_items = response.data.items.map((item) => {
				return {item_id: item.id, order: item.order}
			});
			group.relation_specs = response.data.specs.map((item) => {
				return {item_id: item.id, spec_id: item.id, order: item.order}
			});
			commit('setGroup', response.data);
			return group;
		},
		async updateItemGroup({commit}, {group, items, rules}) {
			const response = await api.updateItemGroup(group.id, group.title, items, rules);
			var group = response.data;
			group.relation_items = response.data.items.map((item) => {
				return {item_id: item.id, order: item.order}
			});
			group.relation_specs = response.data.specs.map((item) => {
				return {item_id: item.id, spec_id: item.id, order: item.order}
			});
			commit('setGroup', group);
		}
	},

	mutations: {
		reset(state) {
			state.groups = {};
			state.groupsArray = [];
			state.roupRequiredMap = {}
		},
		setGroupRequired(state, {groupId, isRequired}) {
			Vue.set(state.groupRequiredMap, groupId, isRequired);
		},
		setGroupItemIds(state, {groupId, itemIds}) {
			var group = state.groups[groupId];
			Vue.set(group, 'item_ids', itemIds);
		},
		setGroups(state, groups) {
			groups.forEach((i) => {
				Vue.set(state.groups, i.id, i);
			});
			Vue.set(state, 'groupsArray', Object.values(state.groups));
		},
		setGroup(state, group) {
			Vue.set(state.groups, group.id, group);
			Vue.set(state, 'groupsArray', Object.values(state.groups));
		},
		deleteGroup(state, groupId) {
			Vue.delete(state.groups, groupId);
			Vue.set(state, 'groupsArray', Object.values(state.groups));
		}
	},
}